/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChatSettings = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M19.5 15.145c.233.069.455.162.665.276l.81-.81 1.414 1.414-.81.81c.114.21.207.432.276.665H23v2h-1.145a3.44 3.44 0 0 1-.276.665l.81.81-1.414 1.414-.81-.81a3.44 3.44 0 0 1-.665.276V23h-2v-1.145a3.483 3.483 0 0 1-.665-.276l-.81.81-1.414-1.414.81-.81a3.483 3.483 0 0 1-.276-.665H14v-2h1.145a3.44 3.44 0 0 1 .276-.665l-.81-.81 1.414-1.414.81.81a3.44 3.44 0 0 1 .665-.276V14h2zM18.5 17a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3z" />
        <path d="M22 13h-2V4H4v16h.501L7.5 16H12v2H8.499L5.5 22H2V2h20z" />
      </g>
    </g>
  </Icon>
);
export { SvgChatSettings as ChatSettings };
